module.exports = __webpack_public_path__ + "static/media/21.23b73a3e.jpg";